/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import logo from '../../images/i1_cc.png';
import GMLabel from '../../images/GM Signature_White.png'
import './Home.css';
import React, {useEffect} from 'react';
import {UnauthenticatedTemplate, useMsal} from "@azure/msal-react";
import {useNavigate} from "react-router-dom";
import ArgosButton from "../../components/Buttons/ArgosButton";

import {Box, Typography} from '@mui/material';

function Home() {
  const navigate = useNavigate();
  const {instance, accounts, inProgress} = useMsal();


  useEffect(() => {

    if (instance.getActiveAccount())
      navigate("/landing")

    document.title = 'Argos Login'
    return () => {
      document.title = 'Argos';
    };
  }, [])
  return (
    <>

      <UnauthenticatedTemplate>
        <div className="Home">

          <head>
            <meta charset="UTF-8"/>
            <title>Login</title>
            <link rel="icon" type="image/x-icon" href="./favicon-32x32.png"/>

            <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/5.0.0/normalize.min.css"/>
            <link rel="stylesheet" type="text/css" href="./style3.css"/>
          </head>
          <body class="login-body full-width">

          {/* <!-- CENTER --> */}
          <div class="wrapper">
            <div class="screen-1">

              {/* <!-- LOGO AND NAME--> */}
              <Box id="ARGOS-branding">
                <div class="logo-container"><img class="logo" src={logo}/></div>
                <div class="brand-container"><Typography variant="h1" class="brand">Argos</Typography></div>
              </Box>

              <div>
                <Typography id="ADAS">Sensing System Architecture</Typography>
              </div>

              {/* <!-- EMAIL
        <Box class="email">
          <FormLabel for="email">Email Address</FormLabel>
          <Grid container class="sec-2">
            <Grid item>
              <Box mr={2} mt={1} display="inline-flex">
                <FontAwesomeIcon icon={faEnvelope} />
              </Box>
              <TextField variant="standard" type="email" name="email" placeholder="GMID@gm.com"/>
            </Grid>
          </Grid>
        </Box>--> */}

              {/* <!-- PASSWORD
        <Box class="password">
          <FormLabel for="password">Password</FormLabel>
          <Grid container class="sec-2">
            <Grid item>
              <Box mr={2} mt={1} display="inline-flex">
                <FontAwesomeIcon icon={faLock}/>
              </Box>
              <TextField variant="standard" type="password" name="pass"placeholder="············"/>
            </Grid>

          </Grid>
        </Box>
 --> */}

              <form action="./Landing/Landing.tsx">
                <center><ArgosButton type="submit" style={{width: '230px', height: '30px'}}
                                     variant="outlined" size="small"
                                     onClick={() => navigate("/landing?login=true")}>Login </ArgosButton></center>
              </form>
              <div style={{textAlign: 'center'}}>
                <a href="./requestaccess" class="request-access" style={{color: "gray", textDecoration: 'none'}}>
                  Request Access
                </a>
              </div>
            </div>
          </div>

          {/* <!--FOOTER--> */}
          <Box class="footer-home" id="branding">
            <img src={GMLabel} alt="General Motors"/>
          </Box>
          </body>
        </div>
      </UnauthenticatedTemplate></>
  );
}

export default Home;
